import {availableBackground,drawBackground} from './Backgrounds';
export function createBackgroundCompositor(onStatus=()=>{}){
 let worker,pending,timer,failed=false,stopped=false,ready;
 let mask,person;
 const fail=()=>{failed=true;clearTimeout(timer);pending?.reject(new Error('Background unavailable'));pending=null;worker?.terminate();worker=null;};
 const request=(message,transfer=[],timeout=2500)=>new Promise((resolve,reject)=>{pending={resolve,reject};timer=setTimeout(fail,timeout);worker.postMessage(message,transfer);});
 const initialize=()=>{
  if(!ready){ready=(async()=>{
   const {default:createWorker}=await import('./backgroundWorkerFactory');if(stopped)throw new Error('Stopped');worker=createWorker();
   worker.onmessage=({data})=>{if(data.type==='error'){fail();return;}clearTimeout(timer);const task=pending;pending=null;task?.resolve(data);};worker.onerror=fail;
   const base=new URL(`${process.env.PUBLIC_URL||''}/models/background`,window.location.href).href;
   await request({type:'init',base},[],20000);
  })();}return ready;
 };
 return {
  async apply(source,target,id){
   id=availableBackground(id);if(id==='none'){target.drawImage(source,0,0);onStatus('');return;}
   const w=source.width,h=source.height;
   // Never show the room unexpectedly if a selected replacement cannot load.
   drawBackground(target,id,w,h,performance.now());
   if(failed||stopped){onStatus('הרקע לא זמין במכשיר זה. בחרו ללא רקע או נסו שוב בשיחה הבאה.');return;}
   try{
    if(!ready)onStatus('טוענים את הרקע…');await initialize();if(stopped)return;
    const bitmap=await createImageBitmap(source);if(stopped){bitmap.close();return;}
    const result=await request({type:'frame',bitmap},[bitmap]);if(stopped)return;
    if(availableBackground(id)!==id)drawBackground(target,availableBackground(id),w,h,performance.now());
    mask=mask||document.createElement('canvas');person=person||document.createElement('canvas');
    mask.width=result.width;mask.height=result.height;mask.getContext('2d').putImageData(new ImageData(result.alpha,result.width,result.height),0,0);
    person.width=w;person.height=h;const ctx=person.getContext('2d');ctx.drawImage(source,0,0);ctx.globalCompositeOperation='destination-in';ctx.drawImage(mask,0,0,w,h);ctx.globalCompositeOperation='source-over';
    if(id==='blur'){target.save();target.filter='blur(14px)';target.drawImage(source,-20,-20,w+40,h+40);target.restore();}
    target.drawImage(person,0,0);onStatus('');
   }catch{if(!stopped){fail();onStatus('הרקע לא זמין במכשיר זה. בחרו ללא רקע או נסו שוב בשיחה הבאה.');}}
  },
  stop(){stopped=true;fail();mask=null;person=null;}
 };
}
